import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Landing from './pages/Landing';
import Home from './pages/Home';
import Error from './pages/Error';
import SharedLayout from './pages/SharedLayout';
import PeakThrills from './pages/Peak-thrills';
import ChillOut from './pages/Chill-out-and-about';
import './style.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
import ScrollToTop from './components/ScrollToTop';
import 'bootstrap/dist/css/bootstrap.min.css';
import Wonders from './pages/Wonders-in-the-wild';
import { useRef } from 'react';
import { useState } from 'react';
import WinterEscapeIntersector from './components/WinterEscapeIntersector';

function App() {
  useEffect(() => {
    Aos.init({
      easing: 'ease-in-out',
      duration: 800,
      offset: 200, // delay the animation until the element is 200 pixels from the viewport
    });
  }, []);

  //AOS scroll animation fix work-around
  useEffect(() => {
    let scrollRef = 0;
    window.addEventListener('scroll', function () {
      // increase value up to 5, then refresh AOS to avoid refreshing while component is being rendered
      scrollRef <= 5 ? scrollRef++ : Aos.refresh()
    });

    return () => {
      window.removeEventListener('scroll')
    }
  }, [])

  //winter escape observer
  const [isWinterEscapeVisible, setIsWinterEscapeVisible] = useState(false);
  const winterEscapeRef = useRef(null);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <WinterEscapeIntersector
        setIsWinterEscapeVisible={setIsWinterEscapeVisible}
        winterEscapeRef={winterEscapeRef}
      />
      <Routes>
        <Route path='/' element={<SharedLayout isWinterEscapeVisible={isWinterEscapeVisible} />}>
          <Route index element={<Landing />} />
          <Route path='home' element={<Home />} />
          <Route path='peak-thrills' element={<PeakThrills winterEscapeRef={winterEscapeRef} />} />
          <Route path='wonders-in-the-wild' element={<Wonders winterEscapeRef={winterEscapeRef} />} />
          <Route path='chill-out-and-about' element={<ChillOut winterEscapeRef={winterEscapeRef} />} />
          <Route path='*' element={<Error />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
